import { PairwiseMap } from './pairwise-map.js'

export class PairwiseSet<K> {
	private map = new PairwiseMap<K, void>()

	addPair(a: K, b: K) {
		this.map.addPair(a, b, undefined)
	}

	removePair(a: K, b: K) {
		this.map.removePair(a, b)
	}

	clear() {
		this.map.clear()
	}

	hasPair(a: K, b: K) {
		return this.map.hasPair(a, b)
	}

	getAllFor(a: K) {
		return this.map.getAllFor(a).map(([k]) => k)
	}
}
